import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	getList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/customer/findCustomerMargin`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getOrderList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/customer/findCustomerOrder`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
}
